var toString = require('../lang/toString');
    /**
     * "Safer" String.toUpperCase()
     */
    function upperCase(str){
        str = toString(str);
        return str.toUpperCase();
    }
    module.exports = upperCase;




/*****************
 ** WEBPACK FOOTER
 ** ./~/mout/string/upperCase.js
 ** module id = 19
 ** module chunks = 0
 **/